import React from 'react';
import NotifierBanner from 'flow/components/custom-components/NotifierBanner';
import { isFlowBrandedCustomer } from 'flow/utils/flow-utils';
import useAppContext from 'flow/hooks/useAppContext';

const CrmFeatureNotifier = () => {
    const { i18next } = useAppContext();
    const onAccept = () => {
        window.open(
            'https://support.telavox.com/en_US/user-management/additional-services',
            '_blank',
        );
    };

    return (
        <div id="crm-feature-notification-banner">
            <NotifierBanner
                theme="warning"
                message={i18next.t(
                    'cti.crm_integration.notification_banner.message',
                )}
                buttonText={
                    !isFlowBrandedCustomer()
                        ? i18next.t('chat.post.message.more')
                        : ''
                }
                handleClick={!isFlowBrandedCustomer() ? onAccept : () => {}}
            />
        </div>
    );
};

export default CrmFeatureNotifier;
